import React from 'react'

function NavbarBanner() {
    return (
        <div className="marquee-container bg-myOrange text-white text-center py-1">
            <div className="marquee">
                <strong>Бесплатна достава</strong> низ цела Македонија за пратки над 3500 денари (Скопје над 1800 денари)
            </div>
        </div>
    )
}

export default NavbarBanner
